export default __webpack_public_path__ + "static/media/C2.bdf6ffad.gif";